import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
// import { AppConfig } from "../app.config";
import { environment } from '../../environments/environment';

@Injectable()
export class ProductService {
  private rootUrl = "http://192.168.1.217:8000";

  constructor(private httpClient: HttpClient) {
    this.rootUrl = environment.API_URL
      ? environment.API_URL
      : this.rootUrl;
  }

  getProducts(options) {
    let data = options ? options : {};
    options.id = localStorage.getItem("userID");
    return this.httpClient.post(this.rootUrl + "/products", data, {});
  }

  getProductById(options) {
    let data = options ? options : {};
    options.id = localStorage.getItem("userID");
    return this.httpClient.post(this.rootUrl + "/product", data, {});
  }

  updateProduct(options) {
    let data = options ? options : {};
    options.id = localStorage.getItem("userID");
    return this.httpClient.post(this.rootUrl + "/products", data, {});
  }
}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/_services/product.service.ts